import type { AxiosInstance } from 'axios';
import { isOffline } from './reachability';
import { syncNow } from './runtime';

let timer: ReturnType<typeof setTimeout> | null = null;

export function scheduleSync(client: AxiosInstance): void {
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    timer = null;
    if (!isOffline()) {
      void syncNow(client);
    }
  }, 400);
}
